import React from 'react';
import {connect} from "react-redux";
import DateDisplay from "../../Boilerplate/DateDisplay";
import {Button, Card, Col, Divider, Row, Typography} from "antd";
import {compose} from "redux";
import {canUpdate} from "../../Boilerplate/permissions";
import {MeetingMinuteFiles} from "./MeetingMinuteFiles";
import ChatWall from "../../Boilerplate/ChatWall";
import {CodeTag} from "../../Boilerplate/CodeTag";
import {compArr} from "../selectors";
import DateTimeDisplay from "../../Boilerplate/DateTimeDisplay";
import UserSmall from "../../Boilerplate/UserSmall";

const MeetingMinuteDetail = ({ meetingMinutes, projectId, onEdit }) => {
  const rowWidth = 24;
  const keyWidth = 11;
  const valWidth = rowWidth - keyWidth;
  return (
    <Row gutter={24}>
      <Col span={17}>
        <Row type='flex' gutter={24}>
          <Col className='bid-dashboard-info' span={12}>
            <Card
              className='bid-dashboard-info bid-dashboard-column-card bid-dashboard-list-card'
              title={<span>
            Meeting Minutes #{meetingMinutes.resource.number} - <DateTimeDisplay date={meetingMinutes.resource.meetingdatetime}/>
          </span>}
              extra={
                <Button.Group>
                  <Button key='1' icon='edit' onClick={onEdit} disabled={!canUpdate(meetingMinutes)}>Edit</Button>
                </Button.Group>
              }
            >
              <Divider>Meeting Summary</Divider>
              <Row className='key-value'>
                <Col span={keyWidth}>Meeting Type</Col>
                <Col span={valWidth} className='formatted-text'>{meetingMinutes.resource.type}</Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Next Meeting Time</Col>
                <Col span={valWidth} className='formatted-text'>{<DateTimeDisplay date={meetingMinutes.resource.nextmeetingdatetime}/> || <Typography.Text type='secondary'>No meeting date/time recorded.</Typography.Text>}</Col>
              </Row>
              <br />
              <p>Created on <DateTimeDisplay date={meetingMinutes.resource.datecreated}/> by <UserSmall id={meetingMinutes.resource.createdbyuserid}/></p>
            </Card>
          </Col>
          <Col className='bid-dashboard-info' span={12}>
            <Card className='bid-dashboard-info bid-dashboard-column-card bid-dashboard-list-card' title='Attendees'>
              <Row>
                <Col span={rowWidth} className='formatted-text'>{meetingMinutes.resource.attendees || <Typography.Text type='secondary'>No attendees recorded.</Typography.Text>}</Col>
              </Row>
            </Card>
          </Col>
          <Col className='bid-dashboard-info' span={24}>
            <Card className='bid-dashboard-info bid-dashboard-column-card bid-dashboard-list-card' title='Meeting Notes'>
              <Divider>Safety</Divider>
              <Row>
                <Col span={rowWidth} className='formatted-text'>{meetingMinutes.resource.safety || <Typography.Text type='secondary'>No safety issues recorded.</Typography.Text>}</Col>
              </Row>
              <Divider>Meeting Notes</Divider>
              <Row>
                <Col span={rowWidth} className='formatted-text'>{meetingMinutes.resource.notes || <Typography.Text type='secondary'>No meeting notes recorded.</Typography.Text>}</Col>
              </Row>
              <Divider>RFIs</Divider>
              <Row>
                <Col span={rowWidth} className='formatted-text'>{meetingMinutes.resource.rfis || <Typography.Text type='secondary'>No related RFIs recorded.</Typography.Text>}</Col>
              </Row>
              <Divider>New Business</Divider>
              <Row>
                <Col span={rowWidth} className='formatted-text'>{meetingMinutes.resource.newbusiness || <Typography.Text type='secondary'>No new business recorded.</Typography.Text>}</Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <MeetingMinuteFiles/>
      </Col>
      <Col span={7}>
        <ChatWall projectId={projectId} meetingMinutesId={meetingMinutes.resource.id}/>
        {/*<Activity/>*/}
      </Col>
    </Row>
  );
};

export default compose(
  connect(
    (state, props) => {
      let projectId = props.match.params.id;
      let meetingMinutes = state.view.subview.data[props.match.params.meetingMinutesId];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'meetingminutes', props.match.params.meetingMinutesId];
      if (!compArr(path, itempath) || loading || !meetingMinutes) return { loading: true };
      return { meetingMinutes, projectId };
    },
    (dispatch, props) => ({
      onEdit: () => props.history.push(`/projects/${props.match.params.id}/meeting-minutes/${props.match.params.meetingMinutesId}/edit`)
    })
  ),
)(MeetingMinuteDetail);



// WEBPACK FOOTER //
// ./src/components/Projects/MeetingMinutes/MeetingMinuteDetail.js